<template>
  <div class="about__wrapper">
    <div class="about__content">
      <div class="about__content-image">
        <div class="clipper about__content-image-clip">
          <img ref="portrait" src="portrait.jpg" alt="" />
        </div>
        <a :href="`mailto:${email}`">
          <div id="circle-wrap">
            <img ref="circle" id="circle" src="contact.png" alt="" />
          </div>
        </a>
      </div>
      <div class="about__content-text">
        <div ref="gif" class="about__gif">
          <img src="hello.gif" alt="" />
        </div>
        <div class="clipper">
          <div
            ref="hello"
            class="about__content-title"
            @mouseenter="animateGifIn"
            @mousemove="animateGifMove"
            @mouseleave="animateGifOut"
          >
            Hello there...
          </div>
        </div>
        <div class="clipper">
          <div ref="body" class="about__content-body">
            My name is David and I am a UI/UX Designer and frontend developer.
            <br /><br />
            I am passionate about the intersection between design and code and
            enjoy working on projects from concept to finalization. <br />
            I get excited about tackling complex problems and thrive in
            collaborative environments. <br />
            My day-to-day work involves understanding problems and needs,
            creating concepts and roadmaps, <br />
            prototyping, and exploring new angles. <br /><br />

            In my spare time, I am an avid paraglider, hiker, photographer, and
            music lover. <br />
            Because I am always looking for new challenges and have set the goal
            to run a trail marathon this year. <br /><br />
            I am currently employed at atwork, but looking for a new job. <br />
            If interested, please don't hesitate to reach out and let's chat or
            meet in person.
          </div>
        </div>
      </div>
    </div>
    <div class="about__content-body-summary">
      <h1>Work experience</h1>
      <div class="about__content-body-summary-block">
        <div class="about__content-body-summary-block-title">
          <h3>2020 - 2023</h3>
          <h2>UI Designer & Frontend Developer at atwork</h2>
        </div>
        <p>
          I began my job as a UI Designer, but soon took on the role of frontend
          developer for a few months as the need arose. Then alternated between
          the two teams and eventually worked roughly 50/50 in both roles.
          <br />
          In addition, I was responsible for the entire hand-off process and
          acted as a liaison between the developers and designers. <br /><br />
          As a designer, I was involved from creating new features and concepts,
          to finalizing designs. As a frontend developer, I was responsible for
          implementing those features in code. <br /><br />
          The biggest project we tackled was a complete redesign of the atwork
          suite, which I championed for over a year. We built an extensive
          design system from the ground up, helping the platform evolve with a
          consistent, intuitive, and scalable design language. <br /><br />
          I also worked with product owners and in-house scientists, created
          roadmaps, and estimated workloads, always striving to assist wherever
          needed.
        </p>
      </div>
      <div class="about__content-body-summary-block">
        <div class="about__content-body-summary-block-title">
          <h3>2020</h3>
          <h2>Freelance at Ubisoft in Paris</h2>
        </div>
        <p>
          From January till May I worked at Ubisoft in Paris on a prototype
          together with
          <a href="http://www.valentinberger.ch" target="_blank">
            <span>Valentin Berger</span></a
          >. <br />
          Sadly that's all I'm allowed to say for now.
        </p>
      </div>
      <div class="about__content-body-summary-block">
        <div class="about__content-body-summary-block-title">
          <h3>2016-2019</h3>
          <h2>Bachelor «Digital Ideation» HSLU</h2>
        </div>
        <p>
          I started my bachelor's degree as a designer, coming from a
          typographers background. But quickly I discovered further interest in
          creating websites and mobile experiences. So I applied in classes as a
          developer instead of a designer, when possible. A lot of my knowledge
          in code is also self taught. In the end I specialized in Web/Mobile
          and User Experience.
        </p>
      </div>
      <div class="about__content-body-summary-block">
        <div class="about__content-body-summary-block-title">
          <h3>2015-2016</h3>
          <h2>Federal vocational baccalaureate</h2>
        </div>
      </div>
      <div class="about__content-body-summary-block">
        <div class="about__content-body-summary-block-title">
          <h3>2011-2015</h3>
          <h2>Apprenticeship as Polygraf FH</h2>
        </div>
        <p>
          I blame my apprenticeship as Polygraf or typographer for my mild
          obsessiveness towards typefaces. In these years I worked at a printing
          company and went to school to learn everything connected to the print
          process from design to technologies.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap';
export default {
  name: 'AboutComponent',
  data: function() {
    return {
      email: 'info@davidgabathuler.ch',
      gif: '',
      hello: '',
    };
  },
  beforeRouteLeave(to, from, next) {
    let tl = gsap.timeline();
    tl.to(this.$refs.portrait, {
      x: -this.$refs.portrait.clientWidth,
      duration: 0.75,
    });
    tl.to(
      this.$refs.circle,
      {
        x: -this.$refs.circle.clientWidth,
        duration: 0.75,
      },
      '-=0.75'
    );
    tl.to(
      this.$refs.hello,
      {
        x: -this.$refs.hello.clientWidth,
        duration: 0.75,
      },
      '-=.75'
    );
    tl.to(
      this.$refs.body,
      {
        x: -this.$refs.body.clientWidth,
        duration: 0.75,
      },
      '-=.65'
    ).then(() => {
      next();
    });
  },
  mounted() {
    this.animateCircle();
    this.animateGif();
    this.animateIn();
  },
  methods: {
    animateIn() {
      let tl = gsap.timeline();
      tl.from(this.$refs.portrait, {
        x: this.$refs.portrait.clientWidth,
        duration: 0.75,
      });
      tl.from(
        this.$refs.circle,
        {
          x: this.$refs.circle.clientWidth,
          duration: 0.75,
        },
        '-=0.75'
      );
      tl.from(
        this.$refs.hello,
        {
          x: this.$refs.hello.clientWidth,
          duration: 0.75,
        },
        '-=.75'
      );
      tl.from(
        this.$refs.body,
        {
          x: this.$refs.body.clientWidth,
          duration: 0.75,
        },
        '-=.65'
      );
    },
    animateCircle() {
      let circle = this.$refs.circle;
      gsap.to(circle, 6, {
        duration: 0,
        rotation: '360',
        ease: 'none',
        repeat: -1,
      });
    },
    animateGif() {
      this.gif = this.$refs.gif;
    },
    animateGifIn() {
      this.gif.style.visibility = 'visible';
    },
    animateGifMove(e) {
      gsap.to(this.gif, 0.3, {
        css: {
          left: e.pageX,
          top: e.pageY,
        },
      });
    },
    animateGifOut() {
      this.gif.style.visibility = 'hidden';
    },
  },
};
</script>
